import styled from "@emotion/styled";

const StyledWorkFlow = styled.div`
  height: calc(100dvh - 20px);
  .workflow-sidebar {
    width: 260px;
    height: 100%;
    border-right: 1px solid #f0f0f0;
    background: #fff;
    padding: 16px 16px 24px;
    overflow-y: auto;
    box-sizing: border-box;
    .workflow-title {
      display: block;
      margin-bottom: 16px;
      font-size: 18px;
    }

    .workflow-group {
      margin-bottom: 18px;
    }

    .workflow-group-title {
      display: block;
      margin-bottom: 8px;
      font-size: 12px;
      color: #8c8c8c;
      text-transform: none;
    }

    .workflow-item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 10px 12px;
      margin-bottom: 8px;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      background: #fff;
      cursor: grab;
      user-select: none;
      transition:
        border-color 0.15s ease,
        box-shadow 0.15s ease;
    }

    .workflow-item:hover {
      border-color: #1677ff;
      box-shadow: 0 0 0 1px rgba(22, 119, 255, 0.13);
    }

    .workflow-item-icon {
      font-size: 16px;
      color: #262626;
    }

    .workflow-item-label {
      font-size: 14px;
    }
  }
  .workflow-div {
    flex: 1;
    display: flex;
    flex-direction: column;
    .ref-div {
      flex: 1;
      background: #fafafa;
    }
    .workflow-node {
      min-width: 220px;
      border: 1.5px solid;
      border-radius: 10px;
      background: #fff;
      overflow: hidden;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    }

    .workflow-node-content {
      padding: 14px 16px 10px;
    }

    .workflow-node-header {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .workflow-node-icon {
      font-size: 18px;
      color: #262626;
    }

    .workflow-node-title {
      flex: 1;
      font-size: 15px;
      font-weight: 600;
      color: #1f1f1f;
    }

    .workflow-node-status {
      margin-top: 4px;
      font-size: 12.5px;
      font-weight: 500;
    }

    .workflow-node-success {
      font-size: 16px;
      color: #22c55e;
    }

    .workflow-node-warning {
      font-size: 16px;
      color: #f59e0b;
    }

    .workflow-handle {
      background: var(--primary) !important;
    }
  }
`;

export default StyledWorkFlow;
